import React from "react";
import { useTranslate, IResourceComponentsProps } from "@pankod/refine-core";
import { Edit, Form, Input, useForm } from "@pankod/refine-antd";
import { IUser } from "interfaces";

export const UserEdit: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();

  const { formProps, saveButtonProps, queryResult } = useForm<IUser>({ redirect: "list" });
  const user = queryResult?.data?.data;
  const title = user ? `${user.email ?? user.username ?? ""}` : "";

  return (
    <Edit saveButtonProps={saveButtonProps} title={`${t("buttons.edit")} ${title}`}>
      <Form {...formProps} layout="vertical">
        <Form.Item label={t("pages.login.mail")} name="email" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item label={t("rooms.name")} name="username" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item label={t("pages.login.password")} name="setpassword">
          <Input />
        </Form.Item>

        <Form.Item label={t("pages.booking.phone")} name="tel" rules={[{ required : true }]}>
          <Input />
        </Form.Item>

      </Form>
    </Edit>
  );
};
